<template>
    <div>

        <div class="flex md:flex-row flex-col mb-12 gap-12">
            <template v-if="loading">
                <sau-spinner class="justify-center w-full" />
            </template>
            <template v-else>
                <div class="bg-white shadow-lg border border-grey-200 md:w-1/2 p-6">
                    <h5>Current Data Usage
                    <i 
                        class="fal fa-question-circle" 
                        v-b-tooltip.hover 
                        title="Current Calendar Month"></i></h5>
                    <p>{{ new Intl.NumberFormat('en-AU').format(service.usage) }} MB</p>
                    <h5>Usage Limit</h5>
                    <p class="mb-0">{{ new Intl.NumberFormat('en-AU').format(service.limit) }} MB</p>
                </div>
                <div v-if="access && service.fields['Login URL']" class="bg-white shadow-lg border border-grey-200 md:w-1/2 p-6">
                    <h5>Username</h5>
                    <p>{{ access.username }}</p>
                    <h5>Password</h5>
                    <password-toggle :password="access.password" />
                    <div class="flex flex-row justify-end gap-4 mt-3">
                        <a 
                            class="btn"
                            href="https://help.serversaustralia.com.au/s/article/Getting-Started-with-an-NSX-Firewall" 
                            target="_blank">Learn More <i class="fal fa-external-link ml-2"></i></a>
                        <a :href="service.fields['Login URL']" target="_blank" class="btn btn-primary">Log In</a>
                    </div>
                </div>
            </template>
        </div>
        <template v-if="Object.keys(service.custom).length > 0">
            <h3>System Details</h3>
            <div class="row">
                <div class="col">
                    <div class="sau-bx p-6">
                        <div class="row">
                            <div v-for="(val, key) in this.col1" :key="key" class="col-sm-12 col-md-6 my-2">
                                <div class="sau-border-bottom pb-2">
                                    <h5>{{ val[0] }}
                                        <button v-b-modal.ip-modal v-if="val[0].includes('ip') || val[0].includes('IP')" class="btn btn-primary float-right text-white py-1" style="font-size: 0.8rem;">View</button>
                                    </h5>
                                    <p class="mb-0">{{ val[1] }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-modal id="ip-modal"
                        centered
                        title="IP Addresses"
                        hide-footer
                        cancel-variant="link"
                        ref="modalEditIp">
                        <div class="row">
                            <div class="col">

                                <template v-if="service.ipaddress">
                                    <h5>Primary IP:</h5>
                                    <p>{{ service.ipaddress }}</p>
                                </template>

                                <template v-if="service.assignedips">
                                    <h5>Assigned IP's:</h5>
                                    <p class="mb-0" v-for="(ip, index) in filteredIps" :key="index">{{ ip }}</p>
                                </template>

                                <template v-if="!service.ipaddress && !service.assignedips">
                                    <h5>No IP addresses found</h5>
                                </template>

                            </div>
                        </div>
                </b-modal>

            </div>
        </template>
    </div>
</template>

<script>

import axios from 'axios';
import SauSpinner from '@v1/utilities/SauSpinner';
import PasswordToggle from '@v1/utilities/PasswordToggle';

export default {
    props: ['service'],

    components: { PasswordToggle, SauSpinner },

    data() {
        return {
            col1: [],
            col2: [],
            access: null,
            loading: true,
        }
    },

    created() {
        this.formatDetails();

        this.getLoginDetails();
    },

    methods: {
        formatDetails() {
            _.forIn(this.service.custom, function(val, key) {
                this.col1.push([key, val]);
            }.bind(this));
        },
        getLoginDetails() {
            this.loading = true;
            return axios.get(`/api/services/firewall/${this.service.id}/login-details`)
                .then(({ data }) => {
                    this.access = data;  
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    },

    computed: {
        filteredIps() {
            return this.service.assignedips.replace(/[\n\r]+/g, ' ').split(' ').filter(ip => ip != '');
        }
    }
}
</script>

<style lang="scss">
    #ip-modal {
        .row {
            max-height: 50vh;
            overflow-y: scroll;
        }
    }
    .sau-border-bottom {
        border-bottom: solid 1px #e5e5e5;
    }
</style>
